import {  SimpleRestaurantResponse } from "@/api/lib/restaurant";

export const findRestaurantNameById = (id: string, restaurants: SimpleRestaurantResponse[] ) => {
  return restaurants.find((restaurant: any) => restaurant.id === id)?.name;
};